var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":typeof(_vm.href)=='undefined'?'javascript:;':_vm.href}},[_c('btn',{attrs:{"type":_vm.type||'primary',"operation":_vm.operation,"disabled":_vm.disabled,"size":"small","loading":_vm.loading},on:{"click":_vm.clickEventProxy}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }